<template>
  <div class="dev-map-show-container">
    <!-- Filter Panel -->
    <div class="form-panel">
      <j-search-select-tag :dictOptions="devOptions" @change="selectDev" placeholder="搜索设备名称、编号"
        style="width: 300px; margin-right: 8px;" v-model="filter.devId" />
      <j-multi-select-tag @change="renderMarkers" dictCode="device_run_status" placeholder="请选择运行状态" type="checkbox"
        v-model="filter.runStatus"></j-multi-select-tag>
      <a-button @click="getDevList" icon="reload" style="margin-left: 8px" />
    </div>

    <!-- Map Container -->
    <div class="map-main" id="map-map-main"></div>

    <!-- Device Info Modal -->
    <a-modal :centered="true" :mask="false" :maskClosable="false"
      :title="selectedDevice ? selectedDevice.devName : '设备详情'" @cancel="infoVisible = false" v-model="infoVisible"
      width="400px">
      <template slot="footer">
        <a-button @click="showAuthModal" type="primary">授权给企业</a-button>
        <a-button @click="handleDetail(selectedDevice)">详情</a-button>
      </template>

      <div class="pop-container" v-if="selectedDevice">
        <p>
          <strong>名称：</strong>
          {{ selectedDevice.devName }}
        </p>
        <p>
          <strong>地址：</strong>
          {{ selectedDevice.location || '暂无地址信息' }}
        </p>
        <p>
          <strong>设备类型：</strong>
          {{ selectedDevice.devClassCode_dictText || '-' }}
        </p>
        <p>
          <strong>设备型号：</strong>
          {{ selectedDevice.devTypeId_dictText || '-' }}
        </p>

        <template v-if="selectedDevice.lastConsumerRecord && selectedDevice.lastConsumerRecord.id">
          <div class="record-info">
            <h4>最近取水记录</h4>
            <p v-if="selectedDevice.lastConsumerRecord.endTime">{{ selectedDevice.lastConsumerRecord.endTime }} 上次加水结束
            </p>
            <p v-else>{{ selectedDevice.lastConsumerRecord.startTime }} 正在加水</p>
            <p>
              <span class="blue-vertical-line"></span>
              班组：{{ selectedDevice.lastConsumerRecord.groupId_dictText }}
            </p>
            <p>
              <span class="blue-vertical-line"></span>
              取水人：{{ selectedDevice.lastConsumerRecord.consumerUserId_dictText }}
            </p>
          </div>
        </template>
      </div>
    </a-modal>

    <!-- Auth Modal -->
    <a-modal :centered="true" :maskClosable="false" title="授权给企业" @cancel="authVisible = false" v-model="authVisible"
      width="400px">
      <j-search-select-tag :getPopupContainer="(node) => node.parentNode" :loading="corpLoading"
        v-model="selectedCorpId" :dictOptions="corpListOptions" style="width: 100%"></j-search-select-tag>
      <template slot="footer">
        <a-button @click="authVisible = false">取消</a-button>
        <a-button @click="handleAuth" type="primary">确定</a-button>
      </template>
    </a-modal>

  </div>
</template>

<script>
import { getAction, postAction } from '@/api/manage'
import DeviceControlModal from './modules/DeviceControlModal'
import coordTransform from '@/utils/coordTransform';
import { putAction } from '../../../../api/manage';

const runstatusStyles = {
  free: '/static/image/wf_marker_free.png',
  busy: '/static/image/wf_marker_busy.png',
  alert: '/static/image/wf_marker_alert.png',
  unAvailable: '/static/image/wf_marker_unavail.png'
}

export default {
  name: 'DevMapShow',
  components: { DeviceControlModal },
  data() {
    return {
      map: null,
      center: [116.397428, 39.90923], // 默认中心点（北京）
      zoom: 12,
      devices: [],
      devOptions: [],
      devMarkers: [], // 用于存储地图标记实例
      filter: {
        devId: null,
        runStatus: 'free,busy,alert' // 默认显示所有状态
      },
      infoVisible: false,
      selectedDevice: null,
      authVisible: false,
      corpList: [],
      corpListOptions: [],
      corpLoading: false,
      selectedCorpId: null,
      url: {
        list: '/device/devList/origin-list', // 只显示可见设备
        devDetail: '/device/devList/queryWfDetail',
        corpList: '/wf/wfConsumerCorp/availCorpList',
        auzEdit: "/wf/wfConsumerCorp/auzEdit",
      }
    }
  },
  computed: {
    isThirdAccount() {
      return this.$store.getters.userInfo.thirdAccount
    },
    // 根据UI控件筛选设备
    filteredDevices() {
      const { runStatus } = this.filter
      if (!runStatus) return []
      const statusArr = runStatus.split(',')
      // 只显示可见设备（mapVisible = 1）
      return this.devices.filter(device => statusArr.includes(device.runStatus))
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initMap()
      this.getDevList()
    })
  },
  beforeDestroy() {
    this.destroyMap()
  },
  methods: {
    // --- 地图方法 ---
    initMap() {
      // 确保天地图API已加载
      if (!window.T || !window.T.Map) {
        this.$message.error('天地图API未加载，请检查index.html是否正确引入！')
        return
      }

      this.map = new window.T.Map('map-map-main', {
        projection: 'EPSG:4326' // 使用经纬度坐标(WGS84)
      })
      this.map.centerAndZoom(new window.T.LngLat(this.center[0], this.center[1]), this.zoom)

      // 添加地图控件
      this.map.addControl(new window.T.Control.Zoom())
      this.map.addControl(new window.T.Control.Scale())
      this.map.addControl(new window.T.Control.MapType())
    },

    // 销毁地图，防止内存泄漏
    destroyMap() {
      if (this.map) {
        this.map.clearOverLays() // 清除所有覆盖物
        this.map = null
      }
      // 清理DOM容器，确保完全释放
      const mapContainer = document.getElementById('map-map-main')
      if (mapContainer) {
        mapContainer.innerHTML = ''
      }
    },

    // 渲染设备标记
    renderMarkers() {
      if (!this.map) return

      // 清除旧标记
      this.devMarkers.forEach(marker => this.map.removeOverLay(marker))
      this.devMarkers = []

      this.filteredDevices.forEach(device => {
        let position = null;
        if (device.coordinateWgs84) {
          position = device.coordinateWgs84.replace('，', ',').split(',').map(Number);
        } else if (device.coordinateGcj02) {
          const gcj02 = device.coordinateGcj02.replace('，', ',').split(',').map(Number);
          position = coordTransform.gcj02ToWgs84(gcj02[0], gcj02[1]);
        }

        if (!position || !position[0] || !position[1]) {
          console.warn(`设备 ${device.devName} 的坐标无效，已跳过。`);
          return;
        }

        let iconUrl = runstatusStyles[device.runStatus] || runstatusStyles.free;
        const icon = new window.T.Icon({
          iconUrl: iconUrl,
          iconSize: new window.T.Point(32, 32),
          iconAnchor: new window.T.Point(16, 32)
        });
        const marker = new window.T.Marker(new window.T.LngLat(position[0], position[1]), { icon });

        // 为标记添加点击事件
        marker.addEventListener('click', () => this.handleMarkerClick(device))

        this.map.addOverLay(marker)
        this.devMarkers.push(marker)
      })
    },

    // --- 数据与业务逻辑 ---
    getDevList() {
      const listUrl = this.url.list
      getAction(listUrl, {
        mapVisible: 1, // 只请求可见设备
        ...this.filter,
        pageSize: 999999
      }).then(res => {
        if (res.success) {
          this.devices = res.result.records
          this.devOptions = this.devices.map(device => ({
            value: device.id,
            text: `${device.devName}`
          }))
          this.renderMarkers() // 获取数据后渲染标记
        } else {
          this.$message.error(res.message)
        }
      })
    },

    async handleMarkerClick(device) {
      this.selectedDevice = device
      try {
        const res = await getAction(this.url.devDetail, { id: device.id })
        if (res.success) {
          this.selectedDevice = {
            ...device,
            ...res.result.detail,
            lastConsumerRecord: res.result.lastConsumerRecord || null
          }
        } else {
          this.$message.error('获取设备详情失败: ' + res.message)
        }
      } catch (error) {
        console.error('获取设备详情失败:', error)
        this.$message.error('获取设备详情失败')
      } finally {
        this.infoVisible = true
      }
    },

    selectDev(id) {
      if (!id) return
      const device = this.devices.find(d => d.id === id)
      if (device) {
        const position = device.coordinateGcj02
          ? device.coordinateGcj02.replace('，', ',').split(',').map(Number)
          : [device.coordinateWgs84 ? device.coordinateWgs84.split(',') : [116.397428, 39.90923]]

        if (position && position[0] && position[1]) {
          this.map.panTo(new window.T.LngLat(position[0], position[1]))
          this.handleMarkerClick(device)
        }
      }
    },

    // 显示授权弹窗
    async showAuthModal() {
      this.selectedCorpId = null
      this.authVisible = true
      await this.getCorpList()
    },

    // 获取企业列表
    async getCorpList() {
      this.corpLoading = true
      const res = await getAction(this.url.corpList, { devId: this.selectedDevice.id })
      if (res.success) {
        this.corpList = res.result;
        this.corpListOptions = this.corpList.map(corp => ({
          value: corp.id,
          text: corp.corpName
        }))
      } else {
        this.$message.error(res.message)
      };
      this.corpLoading = false
    },

    // 处理授权
    handleAuth() {
      if (!this.selectedCorpId) {
        this.$message.warning('请选择企业')
        return
      }

      // 找出新增的元素
      const added = [{
        devId: this.selectedDevice.id,
        corpId: this.selectedCorpId
      }];
      putAction(this.url.auzEdit, {
        added, removed: [] // 目前只处理新增授权，未处理取消授权
      }).then(res => {
        if (res.success) {
          this.$message.success('授权成功')
          this.authVisible = false
        } else {
          this.$message.error(res.message || '授权失败，请重新操作')
        }
      })
    },

    handleDetail(device) {
      this.$bus.$emit('to-page-detail', {
        name: 'FusionDevice',
        id: device.id,
        type: 'drawer'
      })
    },
  }
}
</script>

<style lang="less" scoped>
.dev-map-show-container {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
}

.form-panel {
  position: absolute;
  top: 10px;
  left: 50px;
  z-index: 999;
  padding: 10px;
  display: flex;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.8);
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.map-main {
  width: 100%;
  height: 100%;
  flex: 1;
}

/* --- 弹窗样式 --- */
.pop-container {
  p {
    margin-bottom: 8px;
    color: #333;

    strong {
      color: #000;
    }
  }
}

.pop-tag {
  display: inline-block;
  padding: 0 6px;
  height: 20px;
  line-height: 20px;
  border-radius: 2px;
  font-size: 12px;
  margin-right: 8px;
  margin-bottom: 8px;
}

.tag-free {
  background-color: #f6ffed;
  border: 1px solid #b7eb8f;
  color: #52c41a;
}

.tag-busy {
  background-color: #fff7e6;
  border: 1px solid #ffd591;
  color: #fa8c16;
}

.tag-alert {
  color: #fff;
  background: #9e9e9e;
  border-color: #b8b8b8;
}

.tag-unavail {
  background-color: #fff1f0;
  border: 1px solid #efd872;
  color: #d3ae0b;
}

.pop-pic {
  display: block;
  max-width: 100%;
  max-height: 200px;
  margin: 10px 0;
  border-radius: 4px;
}

.record-info {
  margin-top: 16px;
  padding: 12px;
  background-color: #f9f9f9;
  border-radius: 4px;
  border: 1px solid #eee;

  h4 {
    margin-top: 0;
    margin-bottom: 8px;
    font-size: 14px;
  }

  p {
    margin-bottom: 4px;
    color: #666;
    display: flex;
    align-items: center;
  }
}

.blue-vertical-line {
  display: inline-block;
  width: 4px;
  height: 14px;
  background-color: #1890ff;
  margin-right: 8px;
}

/deep/ .ant-modal-body {
  padding: 16px;
}
</style>
